<div class="content-blk">
  <div class="container dv-invt-mmbr">
    <h5 [routerLink]="[ '/store/team']" class="page-title">
      <i class="fa fa-angle-left" aria-hidden="true"></i> Team
    </h5>
    <div class="row" >
      <div class="col-lg-6">
      <h4>Invite member</h4>
    </div>
    <div class="col-lg-5 dv-send-invite">
      <button (click)="sendInvite()" [disabled]="InviteeMail == null || InviteeMail.trim() == '' || !InviteeMail.includes('@') || !InviteeMail.includes('.')" mat-raised-button color="primary">Send invite</button>
    </div>
    <div class="col-lg-1">
    </div>
    </div>
    <div class="store-set-blk vw-pro-ux" >
      <div class="store-set-ui">
        <div class="row dv-owners">
          <div class="col-lg-4 mat-crd-ui" *ngIf="isOwner">
            Owner email
            <br>
            <p>Owner can see or manage sensitive business information such as financial data if you give
              them access. </p>
          </div>
          <div class="col-lg-4 mat-crd-ui" *ngIf="!isOwner">
            Staff member email
            <br>
            <p> Staff member can only see or manage sensitive business information such as financial data if you give
              them access. </p>
          </div>
          <div class="col-lg-7 mat-crd-ui dv-email-area">
            <p>Email</p>
            <input type="email" matInput [(ngModel)]="InviteeMail">
          </div>
          <div class="col-lg-1">

          </div>
        </div>
      </div>
    </div>
    <hr *ngIf="!isOwner">
    <div class="store-set-blk vw-pro-ux" *ngIf="!isOwner">
      <div class="store-set-ui">
        <div class="row dv-owners">
          <div class="col-lg-4 mat-crd-ui">
            Sensitive permissions
            <br>
            <p> Enable staff members to edit and view business sensitive parts of the partner dashboard. </p>
          </div>

          <div class="col-lg-7 mat-crd-ui dv-permisson">
            <div class="dv-mng-prmssn">
              <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="tree" [class.isEdit]="IsEditCase">
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                  <mat-checkbox class="checklist-leaf-node"
                                [checked]="checklistSelection.isSelected(node)"
                                (change)="todoLeafItemSelectionToggle(node)"
                                [disabled]="IsEditCase">
                    {{node.Permission}}
                  </mat-checkbox>
                </mat-tree-node>
                <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                  <div class="mat-tree-node">
                    <mat-icon class="mat-icon-rtl-mirror" matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.Permission">
                      {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                    </mat-icon>
                    <mat-checkbox [checked]="descendantsAllSelected(node)"
                                  [indeterminate]="descendantsPartiallySelected(node)"
                                  (change)="todoItemSelectionToggle(node)"
                                  [disabled]="IsEditCase">
                      {{node.Permission}}
                    </mat-checkbox>
                  </div>
                  <div [class.tree-invisible]="!treeControl.isExpanded(node)"
                       role="group">
                    <ng-container matTreeNodeOutlet></ng-container>
                  </div>
                </mat-nested-tree-node>
              </mat-tree>
            </div>
          </div>
          <div class="col-lg-1">

          </div>
        </div>
      </div>
    </div>
   
  </div>
</div>